import styled from '@emotion/styled'

export const StatusIconContainer = styled.div<{ 
  bg: string; 
  isCompact?: boolean;
  variant?: 'card' | 'table';
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ isCompact }) => isCompact ? '100%' : '36px'};
  height: ${({ isCompact, variant }) => {
    if (isCompact && variant === 'table') return '42px';
    if (isCompact) return '28px';
    return '36px';
  }};
  border-radius: 8px;
  background-color: ${({ bg }) => bg};
  flex-shrink: 0;
  padding: ${({ variant }) => variant === 'table' ? '4px 8px' : '0'};
  cursor: pointer;
  
  @media (max-width: 768px) {
    width: ${({ isCompact }) => isCompact ? '100%' : '32px'};
    height: ${({ isCompact, variant }) => {
      if (isCompact && variant === 'table') return '28px';
      if (isCompact) return '24px';
      return '32px';
    }};
    padding: ${({ variant }) => variant === 'table' ? '2px 6px' : '0'};
  }
`
